import React, { SVGProps } from 'react';

const HomeIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.666626 3.16675C0.666626 2.06218 1.56206 1.16675 2.66663 1.16675H6.66663C7.7712 1.16675 8.66663 2.06218 8.66663 3.16675V8.50008C8.66663 9.60465 7.7712 10.5001 6.66663 10.5001H2.66663C1.56206 10.5001 0.666626 9.60465 0.666626 8.50008V3.16675ZM2.66663 2.50008C2.29844 2.50008 1.99996 2.79856 1.99996 3.16675V8.50008C1.99996 8.86827 2.29844 9.16675 2.66663 9.16675H6.66663C7.03482 9.16675 7.33329 8.86827 7.33329 8.50008V3.16675C7.33329 2.79856 7.03482 2.50008 6.66663 2.50008H2.66663Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.3334 12.5C11.3334 11.3954 12.2288 10.5 13.3334 10.5H17.3334C18.4379 10.5 19.3334 11.3954 19.3334 12.5V17.8333C19.3334 18.9379 18.4379 19.8333 17.3334 19.8333H13.3334C12.2288 19.8333 11.3334 18.9379 11.3334 17.8333V12.5ZM13.3334 11.8333C12.9652 11.8333 12.6667 12.1318 12.6667 12.5V17.8333C12.6667 18.2015 12.9652 18.5 13.3334 18.5H17.3334C17.7016 18.5 18 18.2015 18 17.8333V12.5C18 12.1318 17.7016 11.8333 17.3334 11.8333H13.3334Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.3334 3.16675C11.3334 2.06218 12.2288 1.16675 13.3334 1.16675H17.3334C18.4379 1.16675 19.3334 2.06218 19.3334 3.16675V5.83342C19.3334 6.93798 18.4379 7.83342 17.3334 7.83342H13.3334C12.2288 7.83342 11.3334 6.93798 11.3334 5.83342V3.16675ZM13.3334 2.50008C12.9652 2.50008 12.6667 2.79856 12.6667 3.16675V5.83342C12.6667 6.2016 12.9652 6.50008 13.3334 6.50008H17.3334C17.7016 6.50008 18 6.2016 18 5.83342V3.16675C18 2.79856 17.7016 2.50008 17.3334 2.50008H13.3334Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.666626 15.1667C0.666626 14.0622 1.56206 13.1667 2.66663 13.1667H6.66663C7.7712 13.1667 8.66663 14.0622 8.66663 15.1667V17.8334C8.66663 18.938 7.7712 19.8334 6.66663 19.8334H2.66663C1.56206 19.8334 0.666626 18.938 0.666626 17.8334V15.1667ZM2.66663 14.5001C2.29844 14.5001 1.99996 14.7986 1.99996 15.1667V17.8334C1.99996 18.2016 2.29844 18.5001 2.66663 18.5001H6.66663C7.03482 18.5001 7.33329 18.2016 7.33329 17.8334V15.1667C7.33329 14.7986 7.03482 14.5001 6.66663 14.5001H2.66663Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default HomeIcon;
